module.exports = __webpack_public_path__ + "static/media/teacher7.a44d27f8.svg";